var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _vm.hasRoleToReadLogs
                ? _c(
                    "el-breadcrumb",
                    {
                      staticStyle: { float: "right" },
                      attrs: { "separator-class": "el-icon-arrow-right" }
                    },
                    [
                      _c(
                        "el-breadcrumb-item",
                        { attrs: { to: { path: "/" } } },
                        [_vm._v(_vm._s(_vm.$t("route.home")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-breadcrumb-item",
                        { attrs: { to: { name: "tournamentList" } } },
                        [_vm._v(_vm._s(_vm.$t("entities.tournament.plural")))]
                      ),
                      _vm._v(" "),
                      _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.model.name))])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("h2", { staticClass: "page-title" }, [
                _vm._v(
                  _vm._s(_vm.$t("entities.tournament.settingGroups.title"))
                )
              ]),
              _vm._v(" "),
              _c("h4", { staticClass: "page-title" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("entities.tournament.settingGroups.description")
                  )
                )
              ]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  [
                    _c(
                      "el-tabs",
                      {
                        attrs: { type: "border-card", "tab-position": "top" },
                        on: { "tab-click": _vm.handleClick },
                        model: {
                          value: _vm.activeName,
                          callback: function($$v) {
                            _vm.activeName = $$v
                          },
                          expression: "activeName"
                        }
                      },
                      [
                        _vm._l(_vm.options.categories, function(item, index) {
                          return _c("el-tab-pane", {
                            key: item.id,
                            attrs: { label: item.label, name: item.id }
                          })
                        }),
                        _vm._v(" "),
                        _c(
                          "transition",
                          { attrs: { name: "fade", mode: "out-in" } },
                          [_c("router-view")],
                          1
                        )
                      ],
                      2
                    )
                  ]
                ],
                2
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-709f65d5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-709f65d5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/tournament/tournament-settings.vue
// module id = null
// module chunks = 